import * as APPDATA from '@/constants/pcConstAppData';

import {AutoProfileSetupMode} from './autoProfileOption';
import {
  BufferVolumeToUse,
  EstimatedFinalConcentration,
  ExchangeStepSize,
  FinalVolume,
  StartingConcentration,
  StartingVolume,
  StartingVolumeFor2ndTube,
  TotalBufferVolumeToUse,
  VolumeToStartAt,
} from './jsonKeys';

/**
 * @enum {String}
 */
export const StopEnum = {
  NONE: 'NONE',
  PAUSED: 'PAUSED',
  CONTINUE: 'CONTINUE',
  MANUAL_CONTROL: 'MANUAL_CONTROL',
  RECOVERY: 'RECOVERY',
};

/**
 * @enum {Number}
 */
export const RecoveryOfLiquidMode = {
  NONE: 1,
  BUFFER: 2,
  AIR: 3,
  AIR_BUFFER: 4,
};

/**
 * @enum {Number}
 */
export const RecoveryNumberOfPump = {
  [RecoveryOfLiquidMode.NONE]: 0,
  [RecoveryOfLiquidMode.AIR]: APPDATA.CONFIGURATION.VOLUME_AIR_RECOVERY.MAX_VALUE,
  [RecoveryOfLiquidMode.BUFFER]: APPDATA.CONFIGURATION.VOLUME_BUFFER_RECOVERY.MAX_VALUE,
  [RecoveryOfLiquidMode.AIR_BUFFER]: 8,
};

/**
 * @enum {String}
 */
export const RecoveryOfLiquidAction = {
  // TODO: typo of the enum value
  STOP_NORMAL_PROCESS: 'STOP_NORMAL_PORCESS',
  STOP_MANUAL_CONTROL: 'STOP_MANUAL_CONTROL',
  START_RECOVERY_OF_LIQUID: 'START_RECOVERY_OF_LIQUID',
  RECOVERY_FROM_STOP_POPUP: 'RECOVERY_FROM_STOP_POPUP',
  RECOVERY_FROM_STOP_ERROR: 'RECOVERY_FROM_STOP_ERROR',
  RECOVERY_FROM_STOP_AUTO: 'RECOVERY_FROM_STOP_AUTO',
};

/**
 * @enum {Number}
 */
export const AutoProfileConstants = {
  FINAL_VOLUME_POP_UP_VALUE_THREE: 3,
  SAFETY_THRESHOLD_POP_UP_VALUE_ZERO: 0,
  NEGATIVE_ONE: -1,
  MIN_VALUE_FINAL_VOL: 0.2,
  MAX_VALUE_FINAL_VOL: 50,
  MAX_VALUE: 1000,
  MIN_VALUE: -1000,
  VOLUME_DIFFERENT_MULTIPLIER: 0.25,
  DEFAULT_STARTING_CONC: 0.1,
  MIN_STARTING_VOL: 1,
  MIN_FINAL_VOL: 0.5,
  SAFETY_WARNING_THRESHOLD_FINAL_VOL_WITH_AUTO_RECOVERY: 2,
  SAFETY_WARNING_THRESHOLD_STARTING_VOL_WITH_AUTO_RECOVERY: 3,
  AUTO_RECOVERY_MIN_FINAL_VOL: 2,
  ZERO_VOLUME: 0,
};

/**
 * @enum {Number}
 */
export const MembraneCutOff = {
  CHIP_3_KDA: 3,
  CHIP_5_KDA: 5,
  CHIP_10_KDA: 10,
  CHIP_30_KDA: 30,
  CHIP_50_KDA: 50,
  CHIP_100_KDA: 100,
  CHIP_300_KDA: 300,
};

/**
 * @enum {String}
 */
export const MembraneTypeOptions = {
  MPES: 1,
  RC: 2,
};

/**
 * @enum {String}
 */
export const ConcentrateStateMapper = {
  [StartingVolume]: 'startVolume',
  [FinalVolume]: 'finalVolume',
  [StartingConcentration]: 'startConcentration',
  [EstimatedFinalConcentration]: 'finalConcentration',
};

/**
 * @enum {String}
 */
export const Concentrate2TubesStateMapper = {
  [StartingVolume]: 'startVolume01',
  [StartingVolumeFor2ndTube]: 'startVolume02',
  [FinalVolume]: 'finalVolume',
  [StartingConcentration]: 'startConcentration',
  [EstimatedFinalConcentration]: 'finalConcentration',
};

/**
 * @enum {String}
 */
export const BufferExchangesStateMapper = {
  [StartingVolume]: 'startVolume',
  [FinalVolume]: 'finalVolume',
  [StartingConcentration]: 'startConcentration',
  [EstimatedFinalConcentration]: 'finalConcentration',
  [VolumeToStartAt]: 'volumeToStartAt',
  [BufferVolumeToUse]: 'bufferVolumeToUse',
  [ExchangeStepSize]: 'exchangeStepSize',
  [TotalBufferVolumeToUse]: 'totalBufferVolumeToUse',
};

/**
 * @enum {Object}
 */
export const AutoProfileStateMapper = {
  [AutoProfileSetupMode[0]]: ConcentrateStateMapper,
  [AutoProfileSetupMode[1]]: Concentrate2TubesStateMapper,
};
